<template>
<div>
    <cTicketingDetail :ticketingDetail="ticketRowObj" :isBooking="true"
        />
</div>
</template>

<script>
import { addClassToBody,removeClassBody } from "../../../../util/util";
import { COMPONENT_NAME,PATHNAME,} from "../../../../util/constants";
import {mapGetters, mapActions} from "vuex";
import cTicketingDetail from "../../../../components/ticketing/cTicketingDetail";
export default {
  name: COMPONENT_NAME.MY_BOOKING_DETAIL,

  components: {
    cTicketingDetail
  },
 
 computed: {
    ...mapGetters("sTicketingQueue", {
      ticketRowObj: "GET_TICKETING_QUEUE"
    }),
     
   
  },
  data() {
    return {
      

    };
  },
     beforeCreate() {    
   addClassToBody(COMPONENT_NAME.MY_BOOKING_DETAIL);
  },
  
   beforeDestroy() {
       this.$root.$emit("toggle-sidebar-minimize", true);

       removeClassBody();
    },
}
</script>